import { TokenDto } from '../services/auth/models/token.dto';

export function buildSessionHandoffUrl(targetUrl: string, token: TokenDto): string {
  const url = new URL(targetUrl);
  const hash = new URLSearchParams({
    token: token.token,
    refreshToken: token.refreshToken,
    expiresAt: token.expiresAt ?? '',
    refreshExpiresAt: token.refreshExpiresAt ?? '',
  });

  url.hash = hash.toString();
  return url.toString();
}

export function readSessionHandoff(): TokenDto | null {
  const raw = globalThis.location.hash.replace(/^#/, '');

  if (!raw) {
    return null;
  }

  const params = new URLSearchParams(raw);
  const token = params.get('token');
  const refreshToken = params.get('refreshToken');

  if (!token || !refreshToken) {
    return null;
  }

  return {
    token,
    refreshToken,
    expiresAt: params.get('expiresAt') ?? '',
    refreshExpiresAt: params.get('refreshExpiresAt') ?? '',
  };
}

export function clearSessionHandoff(): void {
  const nextUrl = `${globalThis.location.pathname}${globalThis.location.search}`;
  globalThis.history.replaceState(null, '', nextUrl);
}
